import { render } from "./CustomerContractsView.vue?vue&type=template&id=7e5db5c5"
import script from "./CustomerContractsView.vue?vue&type=script&lang=js"
export * from "./CustomerContractsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__